import React from 'react';

// Toast notifications are disabled per client request. The FlashMessages API is
// kept as a no-op so existing call sites (and their guard logic) continue to work
// without surfacing any in-iframe toast or forwarding an `enrichly:toast` to the parent.
const noop = (_content?: React.ReactNode) => {};

const FlashMessages = {
  success: noop,
  info: noop,
  warn: noop,
  error: noop,
};

export default FlashMessages;
